import React, { useEffect, useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import Authorize from '../../components/AuthComponent/Authorize';
import SaveButton from '../../components/Buttons/SaveButton';
import ButtonBar from '../../components/Fields/ButtonBar';
import DateControl from '../../components/Fields/DateControl';
import Field from '../../components/Fields/Field';
import FieldLabel from '../../components/Fields/FieldLabel';
import Form from '../../components/Fields/Form';
import TextboxField from '../../components/Fields/TextboxField';
import { FormConfig } from '../../components/Fields/Types';
import useValidation from '../../components/Hooks/ValidationHook/useValidation';
import SpinnerOverlay from '../../components/Spinner/SpinnerOverlay';
import { HorizontalTabs } from '../../components/Tabs/HorizontalTabs';
import { ApplicationFunctions } from '../../contexts/authContext';
import { useNotifications } from '../../contexts/notificationContext';
import SizeModel from '../../models/SizeModel';
import SizeSetModel from '../../models/SizeSetModel';
import DataService from '../../services/data.service';
import { Result } from '../../types/Result';
import Unauthorized from '../Authentication/Unauthorized';
import SizeSet_tab_Sizes from './Tabs/SizeSet_tab_Sizes';

const SizeSetView: React.FC = () => {
    const [serverErrors, setServerErrors] = useState<Result>();
    const { handleResult, handleException } = useNotifications();
    const [isAuthorized, setIsAuthorized] = useState<boolean>(true);
    const [formData, setFormData] = useState<SizeSetModel>();

    var id = useParams().id;

    useEffect(() => {
        if (id !== undefined) {
            DataService.getById<SizeModel>('api/v1/sizesets/', id)
                .then(response => setFormData(response))
                .catch(e => {
                    if (e.response?.data?.status === 401)
                        setIsAuthorized(false);
                    else
                        handleException(e);
                });
        }
    }, [id]);

    function submit() {
        if (formData) {
            DataService
                .update<SizeModel>(`api/v1/sizesets/`, formData)
                .then(response => {
                    handleResult(response);
                    setServerErrors(response);
                    if (response.isSuccesful === true && response.data)
                        setFormData(response.data);
                })
                .catch(e => handleException(e));
        }
    }

    const formConfig: FormConfig = {
        fields: [
            { name: 'name', label: 'Name', validationRules: [{ type: 'isRequired' }] },
            { name: 'beginDate', label: 'Active from', validationRules: [{ type: 'isRequired' }, { type: 'isDate' }] },
            { name: 'endDate', label: 'Active Until', labelSize: 'auto', validationRules: [{ type: 'isDate' }] },
        ],
        handleSubmit: submit,
        showErrors: 'always',
    };

    const { getFieldProps, getLabelProps, getControlProps, getSubmitButtonProps } = useValidation(formConfig, formData, serverErrors);

    if (!isAuthorized)
        return (<Unauthorized />);

    if (!formData)
        return <SpinnerOverlay />

    return (
        <div className='main-content'>
            <Form title='Size' footer={(
                <Row>
                    <Col md='12'>
                        <ButtonBar offset={2}>
                            <Authorize applicationFunction={ApplicationFunctions.EditSize}>
                                <SaveButton  {...getSubmitButtonProps()} />
                            </Authorize>
                        </ButtonBar>
                    </Col>
                </Row>
            )}>
                <Container fluid>
                    <Row>
                        <Col md='12'>
                            <TextboxField {...getFieldProps('name')} />
                            <Field {...getLabelProps('beginDate')}>
                                <DateControl {...getControlProps('beginDate')} />
                                <span style={{ padding: '7px 15px' }}><FieldLabel {...getLabelProps('endDate')} /></span>
                                <DateControl {...getControlProps('endDate')} />
                            </Field>
                        </Col>
                    </Row>
                </Container>
            </Form>
            <Container fluid>
                <Row>
                    <Col md='12'>
                        <HorizontalTabs
                            id='htabs'
                            defaultActiveKey='sizes'
                            tabs={[
                                {
                                    title: 'Sizes',
                                    eventKey: 'sizes',
                                    component: <SizeSet_tab_Sizes id={formData.id} />,
                                },
                            ]}
                        />
                    </Col>
                </Row>
            </Container>
        </div>
    );
}
export default SizeSetView;